module.exports = __webpack_public_path__ + "img/zoom-addin-03.9f7cc50b.png";